import { render, staticRenderFns } from "./GoogleTable.vue?vue&type=template&id=887dec3c&"
import script from "./GoogleTable.vue?vue&type=script&lang=ts&"
export * from "./GoogleTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports